import React from 'react';

import {
  ICON_NAMES,
  LEFT_HAND_NAV_ICON_NAMES,
  MaterialDesignIcon,
} from '../../../util/material-design-icons';
import { MESSAGE_TYPE } from '../../../util/message-types';
import { START_DATE_TRIGGERED_COMMUNICATION_TYPES } from '../../../util/start-date-triggered-communication-types';
import { isApplicantAutomation } from '../../utils/is-applicant-automation';

export const AutomationMessageTypeIcon = ({
  automation,
}: {
  automation: StartDateTriggeredCommunication | ApplicantAutomation;
}) => {
  let applicantMessageType;
  let employeeCommunicationType;
  if (isApplicantAutomation(automation)) {
    applicantMessageType = automation.messageType;
  } else {
    employeeCommunicationType = automation.communicationType;
  }

  if (employeeCommunicationType === START_DATE_TRIGGERED_COMMUNICATION_TYPES.SURVEY) {
    return (
      <MaterialDesignIcon
        iconName={LEFT_HAND_NAV_ICON_NAMES.SURVEYS}
        className="u-margin-top-xs"
        size="xs"
      />
    );
  }
  if (
    employeeCommunicationType === START_DATE_TRIGGERED_COMMUNICATION_TYPES.MESSAGE ||
    applicantMessageType === MESSAGE_TYPE.TEXT
  ) {
    return <MaterialDesignIcon className="u-margin-top-xs" iconName={ICON_NAMES.FORUM} size="xs" />;
  }
  if (
    employeeCommunicationType === START_DATE_TRIGGERED_COMMUNICATION_TYPES.ALERT ||
    applicantMessageType === MESSAGE_TYPE.EMAIL
  ) {
    return <MaterialDesignIcon iconName={ICON_NAMES.EMAIL} className="u-margin-top-xs" size="xs" />;
  }
  return null;
};
